var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { styled } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AppointmentCustomerComplaint, AppointmentStandardJobSaveUrl, AppointmentUpsertCustomerVoiceToJobItemUrl, GetAppointmentPeriodicPart, appointmentDetailsGetByIdAPI, getSavedApptStandardJobsURl, upsertPMPartsUrl } from '../../api/url';
import { MuiStack } from '../../components';
import { APISchema, EParentModuleName, ESystemName, StatusEnum } from '../../constants';
import { showLoader } from '../../redux/commonSlice';
import { getByIdAPI } from '../../redux/crudSlice';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { systemColor } from '../../theme/systemColor';
import { scrollToTop } from '../../utils/utils';
import TaskDetailsComponent from '../commonViews/taskDetails/taskDetails';
var Img = styled("img")(function (_ref) {
    var theme = _ref.theme;
    return {
        height: "48px",
        marginRight: "5px",
        width: "48px"
    };
});
var TaskDetailsAppointment = function () {
    var _ModuleDetailsGetById;
    var dispatch = useAppDispatch();
    var appointmentId = useParams().appointmentId;
    var _a = useState(false), openPopup = _a[0], setOpenPopup = _a[1];
    var ModuleDetailsGetById = useAppSelector(function (state) { return state.crud; }).ModuleDetailsGetById;
    var navigate = useNavigate();
    var isDisabled = [StatusEnum.Inward, StatusEnum.Cancelled, StatusEnum.Closed].includes((ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById === void 0 ? void 0 : _ModuleDetailsGetById.Key) || "");
    var handleConfirmClick = function () {
        setOpenPopup(true);
    };
    useEffect(function () {
        scrollToTop();
        appointmentDetails();
    }, []);
    var appointmentDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "ModuleDetailsGetById",
                            url: appointmentDetailsGetByIdAPI + appointmentId + "/Get"
                        }))];
                case 1:
                    result = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    return [2 /*return*/];
            }
        });
    }); };
    var handleYesJobCardSubmitClick = function () {
        // Navigate(`/appoinment-tasksDetails/:${appointmentId}`)
        setOpenPopup(false);
    };
    var goToHomePage = function () {
        navigate('/appointment');
    };
    return /*#__PURE__*/ React.createElement(MuiStack, {
        paddingTop: 1,
        width: '100%',
        bgcolor: systemColor.backgroundColor
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        width: '100%'
    }, /*#__PURE__*/ React.createElement(TaskDetailsComponent, {
        isFromAppointmentTask: true,
        parentModuleName: EParentModuleName.Appointment,
        SaveStandaredJobUrl: AppointmentStandardJobSaveUrl,
        getSavedStandaredJobUrl: getSavedApptStandardJobsURl,
        getSavedPeriodicPartsUrl: GetAppointmentPeriodicPart,
        upsertPMPartsUrl: upsertPMPartsUrl(APISchema.Appointment),
        parentModuleDocumentId: appointmentId !== null && appointmentId !== void 0 ? appointmentId : "",
        getCustomerComplaintListUrl: AppointmentCustomerComplaint,
        saveTranslateToJobItemUrl: AppointmentUpsertCustomerVoiceToJobItemUrl,
        apiRequestParam: 'Appoinment',
        isDisabled: isDisabled,
        documentId: appointmentId,
        SystemName: ESystemName.Appointment
    })));
};
export default TaskDetailsAppointment;
